import React from 'react';
import { IIconProps, sizeMap } from './types';

export const InsightsIcon = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4076 4.85714H4.06345C3.11477 4.85714 2.34572 5.67277 2.34572 6.6789V14.381M22.1016 7.71428V20.1782C22.1016 21.1844 21.3325 22 20.3838 22H4.06344C3.11477 22 2.34572 21.1844 2.34572 20.1782V19.619M2.86104 9.07251H13.5043M20.8216 9.07251H21.587M1 18.1903L2.43528 15.8222L5.49095 19.1428L8.63393 11.0475L12.6749 13.9047L16.2669 8.19037L18.959 9.61905L23 2"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
